import { combineReducers } from 'redux';

import list from './list';
import selected from './selected';
import cancel from './cancel';

export default combineReducers({
  list,
  selected,
  cancel,
});
